module.exports = __webpack_public_path__ + "media/images/order-99a995ee7505b24662c90818515be3ca.png";